function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { CheckboxGroupChangeModelLazy } from '../../../models/CheckboxGroupChangeModel';
import { CheckboxGroupItemChangeModel } from '../../../models/CheckboxGroupItemChangeModel';
export function prepareSingleInOneGroupCheckboxGroupItemChangeModel(nestedCheckboxesService, values, checkboxGroupItem) {
  var calcAllValues = function calcAllValues() {
    var groupValuesCollection = new Set(nestedCheckboxesService.group.items.map(function (item) {
      return item.value;
    }));
    var newValues = Array.of();
    var isCheckboxValueInValues = false;

    for (var _i = 0, _Array$from = Array.from(values); _i < _Array$from.length; _i++) {
      var value = _Array$from[_i];

      if (checkboxGroupItem.value === value) {
        isCheckboxValueInValues = true;
      } else if (!groupValuesCollection.has(value)) {
        newValues.push(value);
      }
    }

    if (!isCheckboxValueInValues) {
      newValues.push(checkboxGroupItem.value);
    }

    return newValues;
  };

  var calcGroupValues = function calcGroupValues() {
    return Array.of(checkboxGroupItem.value);
  };

  var calcGroupItems = function calcGroupItems() {
    var result = Array.of();

    var _iterator = _createForOfIteratorHelper(nestedCheckboxesService.group.items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (item.value === checkboxGroupItem.value) {
          result.push(item);
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  };

  var checkboxGroupChangeModel = new CheckboxGroupChangeModelLazy(nestedCheckboxesService.group, calcAllValues, calcGroupValues, calcGroupItems);
  return new CheckboxGroupItemChangeModel(checkboxGroupChangeModel, checkboxGroupItem);
}